function tryInit() {
  const scroll = document.querySelector('.swatch-view');
  const wrapper = document.querySelector('.swatch-single');

  if (!scroll || !wrapper) {
    setTimeout(tryInit, 300);
    return;
  }

  function updateFade() {
  const scrollLeft = scroll.scrollLeft;
  const maxScroll = scroll.scrollWidth - scroll.clientWidth;

  // лівий fade
  if (scrollLeft > 5) {
    wrapper.classList.add('show-left-fade');
  } else {
    wrapper.classList.remove('show-left-fade');
  }

  // правий fade
  if (scrollLeft >= maxScroll - 5) {
    wrapper.classList.add('hide-right-fade');
  } else {
    wrapper.classList.remove('hide-right-fade');
  }
}

  scroll.addEventListener('scroll', updateFade);
  updateFade();
}

tryInit();